import { connect } from 'react-redux';
import partial from 'lodash/partial';
import { updateHistoryPage as updatePage, fetchHistoryPageIfNeeded } from 'common/ducks/payout';
import PaymentsTable from 'account/components/payout/payments_table';

const mapStateToProps = ({payout: {history}}) => {
  return {
    type: 'history',
    items: history.pages[history.currentPage - 1],
    pageCount: history.pageCount,
    currentPage: history.currentPage
  };
}

export default connect(mapStateToProps, {
  updatePage,
  fetch: partial(fetchHistoryPageIfNeeded, 1)
})(PaymentsTable);



// WEBPACK FOOTER //
// ./account/containers/payout/history_payments_table.js